import { render, staticRenderFns } from "./modalEditarInformacion.vue?vue&type=template&id=c2bce906&scoped=true"
import script from "./modalEditarInformacion.vue?vue&type=script&lang=js"
export * from "./modalEditarInformacion.vue?vue&type=script&lang=js"
import style0 from "./modalEditarInformacion.vue?vue&type=style&index=0&id=c2bce906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bce906",
  null
  
)

export default component.exports